<section class="flex-column">
  <article class="dialog-content flex-column gap-8">
    <h2 class="font-weight-semibold">{{ 'PRODUCT_CONFIGURATION.OPEN_IN_CADCAM' | bmsTranslate: {object: data.name} }}</h2>
    <p class="b1 font-weight-regular multi-line">{{ 'PRODUCT_CONFIGURATION.WARNING' | bmsTranslate }}</p>
  </article>
  <vdw-footer chooseEventName="CONFLICTS.CONTINUE_WITHOUT_SAVING" [centered]="true" [chooseDialogCloseValue]="true"></vdw-footer>
</section>
